import { useEffect, useState } from "react";
import { Hourglass } from "lucide-react";
import api from "@/lib/api";

const daysTo = (d) => Math.max(0, Math.ceil((new Date(d) - new Date()) / 86400000));

export default function HolidayCountdown({ childId, from, until }) {
  const [p, setP] = useState(null);
  const soon = from && new Date(from) > new Date();
  useEffect(() => { if (!soon) api.get(`/children/${childId}/holiday/progress`).then(({ data }) => setP(data)).catch(() => {}); }, [childId, soon]);
  if (soon) {
    const d = daysTo(from);
    return (
      <p className="mt-2 inline-flex items-center gap-2 rounded-full bg-white border-2 border-slate-900 px-4 py-1.5 font-bold" data-testid="kid-holiday-opens-in">
        <Hourglass size={16} className="text-orange-500" /> Your pack opens in {d} day{d === 1 ? "" : "s"}! / Ton pack ouvre dans {d} jour{d === 1 ? "" : "s"} !
      </p>
    );
  }
  if (!p) return null;
  const days = daysTo(until);
  const total = p.pack_total || 0;
  const done = Math.min(p.done, total);
  const left = total - done;
  const perDay = Math.ceil(left / Math.max(1, days));
  return (
    <div className="mt-3 rounded-2xl bg-white border-2 border-slate-900 p-3" data-testid="kid-holiday-countdown">
      <p className="font-black text-lg flex items-center gap-2" data-testid="kid-holiday-days-left"><Hourglass size={18} className="text-orange-500" /> {days} day{days === 1 ? "" : "s"} left until 15 January / jours avant le 15 janvier</p>
      <div className="h-4 mt-2 rounded-full bg-orange-100 border-2 border-slate-900 overflow-hidden"><div className="h-full bg-orange-400 transition-[width] duration-700" style={{ width: `${total ? (100 * done) / total : 0}%` }} /></div>
      <p className="font-parent text-sm mt-1.5" data-testid="kid-holiday-pack-progress">
        {p.finished ? "Pack finished — you won the 3 holiday avatars! / Pack terminé, bravo !"
          : <><b>{done}/{total}</b> questions done. Do about <b>{perDay}</b> question{perDay === 1 ? "" : "s"} a day to finish in time! / Fais environ <b>{perDay}</b> questions par jour pour finir à temps !</>}
      </p>
    </div>
  );
}
